import React from 'react';
import { classNames } from '../../utils/classNames';

type StatusTone = 'default' | 'success' | 'warning' | 'danger' | 'info';

const toneStyles: Record<StatusTone, string> = {
  default: 'bg-surface-subtle text-[var(--app-text-muted)] ring-[color:var(--app-border)]',
  success: 'bg-success/10 text-success ring-success/20',
  warning: 'bg-warning/10 text-warning ring-warning/20',
  danger: 'bg-danger/10 text-danger ring-danger/20',
  info: 'bg-primary-50 text-primary-600 ring-primary-100',
};

type StatusBadgeProps = {
  tone?: StatusTone;
  leadingIcon?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  tone = 'default',
  leadingIcon,
  className,
  children,
}) => {
  return (
    <span
      className={classNames(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset',
        toneStyles[tone],
        className
      )}
    >
      {leadingIcon ? <span className="flex h-3.5 w-3.5 items-center justify-center">{leadingIcon}</span> : null}
      {children}
    </span>
  );
};

export default StatusBadge;

